import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "admin-section" }
const _hoisted_2 = ["action"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { style: {"margin-top":"1.3em"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_NcTextField = _resolveComponent("NcTextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$options.title), 1),
    _createElementVNode("p", null, [
      (_ctx.status)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_NcNoteCard, { type: _ctx.gisStatusType }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.gisStatus), 1)
              ]),
              _: 1
            }, 8, ["type"]),
            (typeof _ctx.status.gis_count === 'number')
              ? (_openBlock(), _createBlock(_component_NcNoteCard, {
                  key: 0,
                  type: _ctx.status.gis_count > 500000 ? 'success' : 'warning'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.status.gis_count > 0
              ? _ctx.t('memories', 'Database is populated with {n} geometries.', { n: _ctx.status.gis_count })
              : _ctx.t('memories', 'Geometry table has not been created.')) + " " + _toDisplayString(_ctx.status.gis_count > 0 && _ctx.status.gis_count <= 500000
              ? _ctx.t('memories', 'Looks like the planet data is incomplete.')
              : String()), 1)
                  ]),
                  _: 1
                }, 8, ["type"]))
              : _createCommentVNode("", true),
            (typeof _ctx.config['memories.gis_type'] !== 'number' || _ctx.config['memories.gis_type'] < 0)
              ? (_openBlock(), _createBlock(_component_NcNoteCard, {
                  key: 1,
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'Reverse geocoding has not been configured ({status}).', {
              status: _ctx.config['memories.gis_type'],
            })), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Memories supports offline reverse geocoding using OpenStreetMap data on MySQL and Postgres.')) + " ", 1),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t(
          'memories',
          'You need to download the planet data into your database. This is highly recommended and has low overhead.',
        )) + " ", 1),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'If the button below does not work for importing the planet data, use the following command:')) + " ", 1),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("code", null, "occ memories:places-setup", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Note: the geometry data is stored in the memories_planet_geometry table, with no prefix.')), 1)
    ]),
    _createElementVNode("form", {
      action: _ctx.placesSetupUrl,
      method: "post",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.placesSetup && _ctx.placesSetup(...args)), ["prevent","stop"])),
      target: "_blank"
    }, [
      _createElementVNode("input", {
        name: "requesttoken",
        type: "hidden",
        value: _ctx.requestToken
      }, null, 8, _hoisted_3),
      _createElementVNode("input", {
        name: "actiontoken",
        type: "hidden",
        value: _ctx.actionToken
      }, null, 8, _hoisted_4),
      _createVNode(_component_NcButton, {
        nativeType: "submit",
        variant: "warning"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Download planet database')), 1)
        ]),
        _: 1
      })
    ], 40, _hoisted_2),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_NcTextField, {
        label: _ctx.t('memories', 'Location search endpoint for metadata editor'),
        "label-visible": true,
        placeholder: "https://nominatim.openstreetmap.org",
        "model-value": _ctx.config['memories.places.search.url'],
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('memories.places.search.url', $event.target.value.trim())))
      }, null, 8, ["label", "model-value"])
    ])
  ]))
}